import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation";

export default {
  name: "clients",
  components: {
    LoadingAnimation,
  },
  data() {
    return {
      dataLoaded: false,
      loadingMessage: "Loading Clients...",
      sortBy: "name",
      filter: "",
      fields: [
        { key: "name", label: "Name", sortable: true },
        { key: "manager", label: "Manager", sortable: true },
        { key: "phoneNumber", label: "Phone", sortable: true },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    clients: function() {
      return this.$store.getters.clientsForTable;
    },
  },
  methods: {
    getClientsByStatus(status) {
      this.dataLoaded = false;
      const jsConn = new JSConn();
      jsConn.formParams = {
        statuses: [status],
      };
      this.$store.dispatch("needClients", jsConn).then(() => {
        this.dataLoaded = true;
        return Promise.resolve();
      });
    },
  },
  created() {
    this.getClientsByStatus("active");
  },
};
